import { useThree } from "@react-three/fiber";
import { forwardRef, useImperativeHandle } from "react";
import { ModelData } from "../../model-space/model-space-ref-exposer/model-space-ref-exposer";
import * as THREE from 'three';

export type LayerEditorExposerRef = {
    getModelData: (uuid: string) => ModelData | undefined;
    setModelPositionAndRotation: (uuid: string, position: THREE.Vector3Tuple, rotation: THREE.EulerTuple) => void;
    setModelMaterial: (uuid: string, material: THREE.Material) => void;
};

export const LayerEditorRefExposer = forwardRef<LayerEditorExposerRef>((props, ref) => {
    const scene = useThree(state => state.scene);
    
    useImperativeHandle(ref, () => ({
        getModelData: (uuid: string) => {
            const model = scene.getObjectByProperty('uuid', uuid);

            if (model) return {
                xPosition: model.position.x,
                yPosition: model.position.y,
                zPosition: model.position.z,
                xRotation: model.rotation.x,
                yRotation: model.rotation.y,
                zRotation: model.rotation.z,
                xScale: model.scale.x,
                yScale: model.scale.y,
                zScale: model.scale.z
            };

            return undefined;
        },
        setModelPositionAndRotation(uuid, position, rotation) {
            const object = scene.getObjectByProperty('uuid', uuid);

            if (object) {
                object.position.x = position[0];
                object.position.y = position[1];
                object.position.z = position[2];

                object.rotation.x = rotation[0];
                object.rotation.y = rotation[1];
                object.rotation.z = rotation[2];
            }
        },
        setModelMaterial: (uuid: string, material: THREE.Material) => {
            const object = scene.getObjectByProperty('uuid', uuid);

            if (object && object.material) object.material = material;
        }
    }), [scene]);

    return null;
});